<validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
<div class="viewer-json">
    <ng-container *ngIf="includeTextBox">
        <h2 *ngIf="includeHeaders">Raw JSON</h2>
        <textarea class="textarea-json" rows="10" spellcheck="false" [(ngModel)]="json"></textarea>
        <button class="btn--primary" (click)="setNodes()">Prettify</button>
    </ng-container>
    <div class="divider" *ngIf="nodes.length">
        <h2 *ngIf="includeHeaders">JSON Tree</h2>
        <p-tree [value]="nodes"></p-tree>
    </div>
</div>
